import classNames from 'classnames';

import { useTimeZonedFunctions } from '/src/hooks';

export function DateDisplay({ className, date }) {
  const { formatDay } = useTimeZonedFunctions();

  return <span className={classNames(className)}>{formatDay(date)}</span>;
}
